import { useMemo } from 'react';
import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import facial from '../../assets/lottie/facial.json';
import transfer from '../../assets/lottie/transfer.json';
import validatingVoiceDesktop from '../../assets/lottie/validatingVoiceDesktop.json';
import validatingVoiceMobile from '../../assets/lottie/validatingVoiceMobile.json';
import { useDeviceSize } from '../../hooks/useDeviceSize';
import { widgetTypeState, widgetTypes } from '../../states';
import { LottieAnimation } from '../lottieAnimation';
import { ContainerValidating } from './Styles';

type ValidatingProps = {
  transferValue: boolean;
};

export const Validating = ({ transferValue }: ValidatingProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useDeviceSize();
  const widgetType = useRecoilValue(widgetTypeState);
  const validatingVoice = isDesktop
    ? validatingVoiceDesktop
    : validatingVoiceMobile;

  const contents = useMemo(() => {
    const animation = transferValue
      ? { animation: transfer, text: t('Making transfer') }
      : {
          animation:
            widgetType === widgetTypes.facial ? facial : validatingVoice,
          text: t('Validating your identity'),
        };
    return animation;
  }, [widgetType, transferValue]);

  return (
    <ContainerValidating
      flexDirection="column"
      flex="1"
      alignItems="center"
      rowGap={isDesktop ? '3' : '1.6'}
    >
      <LottieAnimation
        animation={contents.animation}
        style={{ height: '25rem' }}
        idTest="identity_validation_lottie_animation"
      />
      <Label
        fontSize="18"
        semibold
        textAlign="center"
        testId="identity_validation_text_description"
      >
        {contents.text}
        ...
      </Label>
    </ContainerValidating>
  );
};
